export const CheckBoxIcon = ({ tag, isDark = false }) => {
  const icons = {
    checked: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="7" fill="#D4FE75" />
        <path
          d="M8 11.7647L11.1429 15L16 10"
          stroke="#0C0C0E"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    default: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="23"
          height="23"
          rx="6.5"
          stroke={isDark ? "#54535D" : "#EDEFF2"}
          fill={isDark ? "#000" : "#F7F7F8"}
        />
      </svg>
    ),
  };

  return icons[tag];
};
